var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.375,
    y: 2.46094,
    width: 33.25,
    height: 33.25,
    rx: 6,
    fill: "url(#paint0_radial_3149_6276)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.375,
    y: 2.46094,
    width: 33.25,
    height: 33.25,
    rx: 6,
    fill: "url(#paint1_radial_3149_6276)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.375,
    y: 2.46094,
    width: 33.25,
    height: 33.25,
    rx: 6,
    fill: "url(#paint2_radial_3149_6276)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 12.5547C27.3125 13.5384 26.515 14.3359 25.5312 14.3359C24.5475 14.3359 23.75 13.5384 23.75 12.5547C23.75 11.5709 24.5475 10.7734 25.5312 10.7734C26.515 10.7734 27.3125 11.5709 27.3125 12.5547Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 25.0234C22.2792 25.0234 24.9375 22.3651 24.9375 19.0859C24.9375 15.8067 22.2792 13.1484 19 13.1484C15.7208 13.1484 13.0625 15.8067 13.0625 19.0859C13.0625 22.3651 15.7208 25.0234 19 25.0234ZM19 22.6484C20.9675 22.6484 22.5625 21.0535 22.5625 19.0859C22.5625 17.1184 20.9675 15.5234 19 15.5234C17.0325 15.5234 15.4375 17.1184 15.4375 19.0859C15.4375 21.0535 17.0325 22.6484 19 22.6484Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.125 18.6109C7.125 14.6206 7.125 12.6254 7.90158 11.1013C8.58468 9.7606 9.67466 8.67061 11.0153 7.98752C12.5394 7.21094 14.5346 7.21094 18.525 7.21094H19.475C23.4654 7.21094 25.4606 7.21094 26.9847 7.98752C28.3253 8.67061 29.4153 9.7606 30.0984 11.1013C30.875 12.6254 30.875 14.6206 30.875 18.6109L30.875 19.5609C30.875 23.5513 30.875 25.5465 30.0984 27.0706C29.4153 28.4113 28.3253 29.5013 26.9847 30.1844C25.4606 30.9609 23.4654 30.9609 19.475 30.9609L18.525 30.9609C14.5346 30.9609 12.5394 30.9609 11.0153 30.1844C9.67466 29.5013 8.58468 28.4113 7.90158 27.0706C7.125 25.5465 7.125 23.5513 7.125 19.5609V18.6109ZM18.525 9.58594H19.475C21.5094 9.58594 22.8923 9.58778 23.9613 9.67512C25.0025 9.76019 25.535 9.91439 25.9065 10.1037C26.8002 10.5591 27.5269 11.2857 27.9823 12.1795C28.1715 12.5509 28.3257 13.0834 28.4108 14.1247C28.4982 15.1936 28.5 16.5766 28.5 18.6109L28.5 19.5609C28.5 21.5953 28.4982 22.9783 28.4108 24.0472C28.3257 25.0885 28.1715 25.6209 27.9823 25.9924C27.5269 26.8862 26.8002 27.6128 25.9065 28.0682C25.535 28.2575 25.0025 28.4117 23.9613 28.4968C22.8923 28.5841 21.5094 28.5859 19.475 28.5859L18.525 28.5859C16.4906 28.5859 15.1077 28.5841 14.0387 28.4968C12.9975 28.4117 12.465 28.2575 12.0935 28.0682C11.1998 27.6128 10.4731 26.8862 10.0177 25.9924C9.82846 25.6209 9.67426 25.0885 9.58918 24.0472C9.50185 22.9783 9.5 21.5953 9.5 19.5609V18.6109C9.5 16.5766 9.50185 15.1936 9.58918 14.1247C9.67426 13.0834 9.82846 12.5509 10.0177 12.1795C10.4731 11.2857 11.1998 10.5591 12.0935 10.1037C12.465 9.91439 12.9975 9.76019 14.0387 9.67512C15.1077 9.58778 16.4906 9.58594 18.525 9.58594Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3149_6276",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.25 27.3984) rotate(-55.3758) scale(30.3045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3149_6276",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0625 36.8984) rotate(-65.1363) scale(26.8307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3149_6276",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.593752 3.64844) rotate(-8.1301) scale(46.1829 9.87805)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5eaa9fcaef50617152537c2cf34d84ab.svg";
export { ForwardRef as ReactComponent };